const defaultState = {
    isPlaying: false,
};

export const getIsStimulusPlaying = (state = defaultState) => state.isPlaying;
